import React, { useState, useEffect } from "react";
import Button from "../../component/shared/Button";
import WatchDemoVideoButton from "../../component/shared/WatchDemoVideoButton";
import { Api } from "../../network/api";
import AddPastModalAnswerModal from "./AddPastModalAnswerModal";
import { DeleteIcon, DownloadIcon } from "../../assets/icons";

const PastModalAnswer = () => {

  const [pastModalAnswers, setPastModalAnswers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetchPastModalAnswers();
  }, []);

  const fetchPastModalAnswers = async () => {
    try {
      setIsLoading(true);
      setError(null);

      try {
        const response = await Api.getPastModalAnswer();
        console.log("Past modal answer response:", response.data);
        const data = response.data;
        if (data) {
          setPastModalAnswers(data.past_model_answers);
        } else {
          throw new Error("No data received from API");
        }
      } catch (apiError) {
        console.error("Error fetching past modal answers:", apiError);
        setError("Failed to load past modal answers. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching past modal answers:", error);
      setError("Failed to load past modal answers. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddPastModalAnswer = async () => {
    await fetchPastModalAnswers();
    setIsModalOpen(false);
  };

const handleDeleteAnswer = async (id) => {
  try {
    await Api.deletePastModalAnswer(id);
    setPastModalAnswers((prev) => prev.filter((answer) => answer.id !== id));
  } catch (error) {
    console.error("Error deleting past modal answer:", error);
  }
};
const handleDownload = (s3Url) => {
  if (!s3Url) {
    console.warn("No S3 URL found.");
    return;
  }
  if (s3Url.startsWith("http://") || s3Url.startsWith("https://")) {
    window.open(s3Url, "_blank");
    return;
  }
  const backendBaseUrl = "https://backend.calbarbible.com/";
  const finalUrl = `${backendBaseUrl}${s3Url.replace(/^\/+/, "")}`;
  window.open(finalUrl, "_blank");
};


  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };
  function getMonthName(monthNumber) {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthNumber - 1] || "Invalid month";
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading past modal answers...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex flex-col lg:flex-row md:items-center space-y-4 lg:space-y-0 justify-between">
            <div>
              <h1 className="md:text-2xl text-xl font-extrabold text-gray-900">
                Past Model Answers
              </h1>
              <p className="text-gray-600 mt-1">
                Manage and upload past model answer papers for reference.
              </p>
            </div>

            <div className="flex items-center space-x-3">
              <WatchDemoVideoButton
                videoUrl={"https://calbarbible-static.s3.us-east-1.amazonaws.com/static/Past+papers+upload.mov"}
                title="Past Papers Upload Demo Video"
              />
              <Button
                onClick={() => setIsModalOpen(true)}
                className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
              >
                Add Past Model Answer
              </Button>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-red-600"></div>
              <span className="ml-3 text-gray-600">
                Loading past model answers...
              </span>
            </div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-6 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Subject Name
                  </th>
                  <th className="px-6 py-6 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Month/Year
                  </th>
                  <th className="px-6 py-6 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    File Name
                  </th>
                  <th className="px-6 py-6 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Uploaded Date
                  </th>
                    <th className="px-6 py-6 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Grade
                  </th>
                  <th className="px-6 py-6 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {pastModalAnswers.map((answer) => (
                  <tr
                    key={answer.id}
                    className="hover:bg-gray-50 transition-colors duration-150"
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">
                        {answer.subject_name}
                      </div>
                    </td>
                    <td className="px-6 py-8 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {getMonthName(answer.month)} {answer.year}
                      </div>
                    </td>
                    <td className="px-6 py-8 whitespace-nowrap">
                      <div className="text-sm text-gray-900 truncate max-w-xs">
                        {answer.original_filename}
                      </div>
                    </td>
                    <td className="px-6 py-8 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {formatDate(answer.created_at)}
                      </div>
                    </td>
                    <td className="px-6 py-8 whitespace-nowrap">
                      <div className="text-sm text-gray-900 font-semibold">
                        {answer.grade}
                      </div>
                    </td>
                    <td className="px-6 py-8 whitespace-nowrap text-center">
                      <div className="flex items-center justify-center space-x-3">
                        <button
                         onClick={() => handleDownload(answer.s3_url)}
                          className="text-red-600 hover:text-red-700 transition-colors duration-200"
                        >
                          <DownloadIcon />
                        </button>
                        <button
                          onClick={() => handleDeleteAnswer(answer.id)}
                          className="text-red-600 hover:text-red-700 transition-colors duration-200"
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {!isLoading && pastModalAnswers?.length === 0 && (
          <div className="text-center py-12">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-12 h-12 text-gray-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              No past model answers found
            </h3>
            <p className="text-gray-600 mb-6">
              Get started by adding your first past model answer.
            </p>
            <Button
              onClick={() => setIsModalOpen(true)}
              className="bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
            >
              Add Your First Past Model Answer
            </Button>
          </div>
        )}
      </div>

      <AddPastModalAnswerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddPastModalAnswer}
      />
    </div>
  );
};

export default PastModalAnswer;
